module.exports = __webpack_public_path__ + "static/014-faf1d4a33c37703ee2f4b35201772db5.png";